export const PROJECT_FORMATS = [
  { id: '720p25', label: '720p 25', res: '1280×720', fps: 25, note: 'HD PAL' },
  { id: '720p50', label: '720p 50', res: '1280×720', fps: 50, note: 'HD sport EU' },
  { id: '720p60', label: '720p 60', res: '1280×720', fps: 60, note: 'HD sport US' },
  { id: '1080i50', label: '1080i 50', res: '1920×1080', fps: 25, note: 'Full HD interlace — broadcast EU (50 pól/s = 25 kl.)' },
  { id: '1080i60', label: '1080i 60', res: '1920×1080', fps: 30, note: 'Full HD interlace — broadcast US (60 pól/s = 30 kl.)' },
  { id: '1080p25', label: '1080p 25', res: '1920×1080', fps: 25, note: 'Full HD kino EU' },
  { id: '1080p30', label: '1080p 30', res: '1920×1080', fps: 30, note: 'Full HD kino US' },
  { id: '1080p50', label: '1080p 50', res: '1920×1080', fps: 50, note: 'Full HD sport EU' },
  { id: '1080p60', label: '1080p 60', res: '1920×1080', fps: 60, note: 'Full HD sport US / streaming' },
  { id: 'uhd4k25', label: 'UHD 4K 25', res: '3840×2160', fps: 25, note: '4K streaming / kino EU' },
  { id: 'uhd4k30', label: 'UHD 4K 30', res: '3840×2160', fps: 30, note: '4K streaming / kino US' },
  { id: 'uhd4k50', label: 'UHD 4K 50', res: '3840×2160', fps: 50, note: '4K sport EU' },
  { id: 'uhd4k60', label: 'UHD 4K 60', res: '3840×2160', fps: 60, note: '4K sport US' },
  { id: 'dci4k24', label: '4K DCI 24', res: '4096×2160', fps: 24, note: '4K DCI — kino cyfrowe' },
  { id: 'dci4k25', label: '4K DCI 25', res: '4096×2160', fps: 25, note: '4K DCI — kino EU' },
  { id: 'dci4k60', label: '4K DCI 60', res: '4096×2160', fps: 60, note: '4K DCI — premium' },
];

export const FORMAT_RANK = {
  '720p25': 1, '720p50': 2, '720p60': 3,
  '1080i50': 4, '1080i60': 4,
  '1080p25': 5, '1080p30': 6, '1080p50': 7, '1080p60': 8,
  'uhd4k25': 9, 'uhd4k30': 10, 'uhd4k50': 11, 'uhd4k60': 12,
  'dci4k24': 9, 'dci4k25': 10, 'dci4k60': 13,
};

export const PORT_MAX_FORMAT = {
  SDI: '1080i50', 'SDI-3G': '1080p60', 'SDI-6G': 'uhd4k30', 'SDI-12G': 'uhd4k60',
  HDMI: 'uhd4k60', DisplayPort: 'dci4k60', HDBaseT: 'uhd4k60', NDI: 'dci4k60',
  'DVI-D': '1080p60', VGA: '1080p60', Composite: '720p25',
};

export const PHYSICAL_COMPAT = {
  SDI: 'sdi', 'SDI-3G': 'sdi', 'SDI-6G': 'sdi', 'SDI-12G': 'sdi',
  HDMI: 'hdmi', DisplayPort: 'displayport', 'DVI-D': 'dvi', VGA: 'vga',
  Composite: 'composite', NDI: 'ndi', HDBaseT: 'hdbaset', SFP: 'sfp', Fiber: 'fiber',
  XLR: 'xlr', Jack: 'jack', 'Mini-Jack': 'minijack', RCA: 'rca',
  'AES-EBU': 'aes-ebu', SPDIF: 'spdif', TOSLINK: 'toslink', 'MADI-BNC': 'madi-bnc',
  'MADI-Opt': 'madi-opt', AES50: 'aes50', Dante: 'dante', AVB: 'avb',
  'USB-C': 'usb-c', 'USB-A': 'usb-a', 'USB-B': 'usb-b', Ethernet: 'ethernet',
  'RS-232': 'rs232', 'RS-422': 'rs422', MIDI: 'midi', GPIO: 'gpio',
  'BNC-TC': 'bnc-tc', 'BNC-Sync': 'bnc-sync', 'IEC-C13': 'iec-c13',
  PowerCon: 'powercon', 'XLR-4': 'xlr4', 'D-Tap': 'dtap', 'NP-F': 'np-f',
};

export function checkConnection(typeA, typeB, formatId) {
  const groupA = PHYSICAL_COMPAT[typeA];
  const groupB = PHYSICAL_COMPAT[typeB];
  if (!groupA || !groupB || groupA !== groupB) {
    return { canConnect: false, status: 'err', message: `${typeA} ≠ ${typeB} — potrzebny konwerter` };
  }

  const maxA = PORT_MAX_FORMAT[typeA];
  const maxB = PORT_MAX_FORMAT[typeB];
  if (!maxA || !maxB || !formatId) return { canConnect: true, status: 'ok' };

  const rankA = FORMAT_RANK[maxA] ?? 999;
  const rankB = FORMAT_RANK[maxB] ?? 999;
  const rankProject = FORMAT_RANK[formatId] ?? 0;
  const bottleneck = Math.min(rankA, rankB);
  const bottleneckType = rankA <= rankB ? typeA : typeB;
  const bottleneckFormat = rankA <= rankB ? maxA : maxB;

  if (bottleneck >= rankProject) return { canConnect: true, status: 'ok' };
  const projectFormat = PROJECT_FORMATS.find(format => format.id === formatId);
  return {
    canConnect: true,
    status: 'warn',
    message: `${bottleneckType} — max ${bottleneckFormat.toUpperCase()} (projekt: ${projectFormat?.label ?? formatId})`,
  };
}
